import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { TruckerConfirmationService } from '../services/trucker-confirmation.service';

@Component({
    selector: 'trucker-confirm-report',
    templateUrl: 'trucker-confirm-report.component.html',
    styles: [],
    standalone: false
})
export class TruckerConfirmReportComponent implements OnInit, AfterViewInit {

    constructor(private _truckerConfirmService: TruckerConfirmationService, private route: ActivatedRoute, private sanitizer: DomSanitizer) {

    }
    errorMessage: string = '';
    reportReady: boolean = false;
    pdfUrl: SafeResourceUrl | undefined;
    iframeHeight: string = '600px';


    getReport() {

        let parm: string = this.route.snapshot.params['id'];
        let dispatchIds = parm.split(',');
        const loadBreakoutOverride = this.route.snapshot.params['breakout'] === 'true';
        if (dispatchIds.length > 0) {
            this._truckerConfirmService.getReportContent(dispatchIds, loadBreakoutOverride).subscribe({
                next: data => {
                    const url = URL.createObjectURL(data);
                    this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
                    this.reportReady = true;
                },
                error: err => {
                    this.errorMessage = err;
                    this.reportReady = true;
                }
            });
        }
        else {
            this.reportReady = true;
        }

    }


    ngOnInit(): void {
        this.getReport();
       
    }

    ngAfterViewInit(): void {
        this.iframeHeight = `${window.innerHeight - 100}px`;
    }
    
}
